// extracted by mini-css-extract-plugin
module.exports = {"bqvz84h":"bqvz84h"};